var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.optionsC.length)?_c('a-radio-group',{attrs:{"value":_vm.value},on:{"change":_vm.onChange}},_vm._l((_vm.optionsC),function(item){return _c('a-radio-button',{key:item.key,attrs:{"value":item.key}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1):_c('div',{staticClass:"warning-color"},[_vm._v(_vm._s(_vm.$t('common_729')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }